import React from 'react';
import {ALL_REACTIONS} from "../../../model2/reaction/const";
import EmojiSymbolDeprecated from "../../icons/common/emoji/emoji-symbol";

type Props = {
    onSelect: callback;
}

export default function AddReaction_FavoriteReactions(props: Props) {

    const favoriteReactions = gd.modules.reactions.favoriteReactions

    return (
        <>
            {_.map(favoriteReactions, (reaction) => (
                <div className="ui5-control-button s-28"
                     onClick={() => props.onSelect(reaction)} key={reaction}>

                    <EmojiSymbolDeprecated symbol={ALL_REACTIONS[reaction]} size="18" />
                </div>
            ))}
        </>)
}